module.exports = __webpack_public_path__ + "static/media/Bariol-Thin.f8f20cb2.woff2";